/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiArtifactMeshFromJSON(json) {
    return StreemApiArtifactMeshFromJSONTyped(json, false);
}
export function StreemApiArtifactMeshFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'meshStorageUrl': !exists(json, 'mesh_storage_url') ? undefined : json['mesh_storage_url'],
        'metadataStorageUrl': !exists(json, 'metadata_storage_url') ? undefined : json['metadata_storage_url'],
        'requestedAt': !exists(json, 'requested_at') ? undefined : (new Date(json['requested_at'])),
        'startedAt': !exists(json, 'started_at') ? undefined : (new Date(json['started_at'])),
        'erroredAt': !exists(json, 'errored_at') ? undefined : (new Date(json['errored_at'])),
        'fulfilledAt': !exists(json, 'fulfilled_at') ? undefined : (new Date(json['fulfilled_at'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
export function StreemApiArtifactMeshToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'status': value.status,
        'mesh_storage_url': value.meshStorageUrl,
        'metadata_storage_url': value.metadataStorageUrl,
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt.toISOString()),
        'started_at': value.startedAt === undefined ? undefined : (value.startedAt.toISOString()),
        'errored_at': value.erroredAt === undefined ? undefined : (value.erroredAt.toISOString()),
        'fulfilled_at': value.fulfilledAt === undefined ? undefined : (value.fulfilledAt.toISOString()),
        'url': value.url,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactMeshStatus;
(function (StreemApiArtifactMeshStatus) {
    StreemApiArtifactMeshStatus["ERROR"] = "STATUS_ERROR";
    StreemApiArtifactMeshStatus["FULFILLED"] = "STATUS_FULFILLED";
    StreemApiArtifactMeshStatus["INVALID"] = "STATUS_INVALID";
    StreemApiArtifactMeshStatus["REQUESTED"] = "STATUS_REQUESTED";
    StreemApiArtifactMeshStatus["STARTED"] = "STATUS_STARTED";
})(StreemApiArtifactMeshStatus || (StreemApiArtifactMeshStatus = {}));
//# sourceMappingURL=StreemApiArtifactMesh.js.map